// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// привел константы к серверному виду, чтобы не делать лишнюю конвертацию
import { CreateMapByObj } from '../CreateMapByObjectUtils';
export var OrderType;
(function (OrderType) {
    OrderType[OrderType["Market"] = 1] = "Market";
    OrderType[OrderType["Stop"] = 2] = "Stop";
    OrderType[OrderType["Limit"] = 3] = "Limit";
    OrderType[OrderType["StopLimit"] = 4] = "StopLimit";
    OrderType[OrderType["TrailingStop"] = 5] = "TrailingStop";
    OrderType[OrderType["Care"] = 6] = "Care";
    OrderType[OrderType["Manual"] = 100] = "Manual";
    OrderType[OrderType["SLTPLimit"] = 101] = "SLTPLimit";
    OrderType[OrderType["SLTPStop"] = 102] = "SLTPStop";
    OrderType[OrderType["TRStop"] = 105] = "TRStop";
    OrderType[OrderType["OCO"] = 250] = "OCO";
    OrderType[OrderType["PositionEdit"] = 1001] = "PositionEdit"; // specific internal type for modification calculating
})(OrderType || (OrderType = {}));
export function getOrderTypeKey(value) {
    switch (value) {
        case OrderType.Market:
            return 'property.Market';
        case OrderType.Limit:
            return 'property.Limit';
        case OrderType.Stop:
            return 'property.Stop';
        case OrderType.StopLimit:
            return 'property.Stop Limit';
        case OrderType.TrailingStop:
            return 'property.Tr. stop';
        case OrderType.OCO:
            return 'property.OCO';
        case OrderType.SLTPLimit:
            return 'property.Take-profit';
        case OrderType.SLTPStop:
            return 'property.Stop-loss';
        case OrderType.TRStop:
            return 'property.Tr. stop loss';
        case OrderType.Manual:
            return 'property.Manual';
        case OrderType.Care:
            return 'property.Care';
        default:
            return 'type: ' + value;
    }
}
// для мапинга ключей локализации
export const OrderTypeMap = CreateMapByObj(OrderType);
Object.freeze(OrderTypeMap);
export function getSortStr(orderType) {
    let textOrder = 'LMT';
    switch (orderType) {
        case OrderType.Market:
            textOrder = 'MKT';
            break;
        case OrderType.Stop:
            textOrder = 'STP';
            break;
        case OrderType.Limit:
            textOrder = 'LMT';
            break;
        case OrderType.StopLimit:
            textOrder = 'STS';
            break;
        case OrderType.TrailingStop:
            textOrder = 'Tr-s';
            break;
        case OrderType.OCO:
            textOrder = 'OCO';
            break;
    }
    return textOrder;
}
export function getFullStr(orderType) {
    let textOrder = 'Market';
    switch (orderType) {
        case OrderType.Market:
            textOrder = 'Market';
            break;
        case OrderType.Stop:
            textOrder = 'Stop';
            break;
        case OrderType.Limit:
            textOrder = 'Limit';
            break;
        case OrderType.StopLimit:
            textOrder = 'StopLimit';
            break;
        case OrderType.TrailingStop:
            textOrder = 'TrailingStop';
            break;
        case OrderType.Care:
            textOrder = 'Care';
            break;
        case OrderType.OCO:
            textOrder = 'OCO';
            break;
    }
    return textOrder;
}
export function sortOrderTypes(orderTypes) {
    const sortedOrderTypes = [...orderTypes];
    const stop = sortedOrderTypes.indexOf(OrderType.Stop);
    const limit = sortedOrderTypes.indexOf(OrderType.Limit);
    if (stop > -1 && limit > -1) {
        const temp = sortedOrderTypes[stop];
        sortedOrderTypes[stop] = sortedOrderTypes[limit];
        sortedOrderTypes[limit] = temp;
    }
    return sortedOrderTypes;
}
